import { FunctionComponent, ReactNode } from "react";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { classNames } from "@/utils/classNames";

/** Uppercase section label inside a settings card (mockup `.subhead`). */
export const SettingsSubhead: FunctionComponent<{ children: ReactNode; className?: string }> = ({
	children,
	className,
}) => (
	<div
		className={classNames(
			"text-[11px] font-bold uppercase tracking-[0.06em] text-text-meta/70",
			className ?? ""
		)}
	>
		{children}
	</div>
);

/** Bordered, lightly tinted block grouping controls (mockup `.subblock`). */
export const SettingsSubBlock: FunctionComponent<{ children: ReactNode; className?: string }> = ({
	children,
	className,
}) => (
	<div
		className={classNames(
			"rounded-lg border border-gray-200 bg-gray-100/40 px-4 py-4",
			className ?? ""
		)}
	>
		{children}
	</div>
);

/** Green "Connected" / grey "Not connected" pill shown in a card header (mockup `.badge-soft`). */
export const ConnectedBadge: FunctionComponent<{ connected: boolean; label: string }> = ({
	connected,
	label,
}) => (
	<span
		className={classNames(
			"inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold",
			connected ? "bg-green-200 text-green-700" : "bg-gray-100 text-text-meta"
		)}
	>
		{connected && <Icon className="h-3 w-3" icon={faCheck} />}
		{label}
	</span>
);
